import React from "react";

//pagination
import TablePagination from "react-js-pagination";

const Pagination = (props) => {
  const handlePage = (page) => {
    props.handlePageChange(page);
  };
  const handleRowsPerPage = (value) => {
    props.handleRowsPerPage(value);
  };

  return (
    <>
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
        <div className="d-flex align-items-center mb-3 mb-md-0">
          <span className="mb-0">Rows</span>
          <select
            className="form-select form-control mr-3 ml-2 mb-0 dropdown"
            style={{ marginLeft: 5, marginTop: 0 }}
            onChange={(e) => {
              handleRowsPerPage(e.target.value);
            }}
          >
            <option className="text-white" value="5">
              5
            </option>
            <option className="text-white" value="10" selected>
              10
            </option>
            <option className="text-white" value="25">
              25
            </option>
            <option className="text-white" value="50">
              50
            </option>
            <option className="text-white" value="100">
              100
            </option>
            <option className="text-white" value="200">
              200
            </option>
            <option className="text-white" value="500">
              500
            </option>
            <option className="text-white" value="1000">
              1000
            </option>
            <option className="text-white" value="5000">
              5000
            </option>
          </select>
        </div>
        <div className="d-flex justify-content-center align-items-center" style={{ overflowX: "auto", maxWidth: "100%" }}>
          <TablePagination
            activePage={props.activePage}
            itemsCountPerPage={props.rowsPerPage}
            totalItemsCount={props.userTotal}
            pageRangeDisplayed={2}
            onChange={(page) => handlePage(page)}
            itemClass="page-item"
            linkClass="page-link"
          />
        </div>
      </div>
    </>
  );
};

export default Pagination;
